export const on = (element, types, handler, selector) => {
	let temp = handler;

	types.split(' ').forEach((type) => {
		if (typeof selector === 'string') {
			temp = function(event) {
				if (event.target && event.target.matches(`${selector}, ${selector} *`)) {
					handler(event);
				}
			};
		}

		handler._proxy = temp;
		element.addEventListener(type, temp);
	});
};

export const off = (element, types, handler) => {
	types.split(' ').forEach((type) => {
		element.removeEventListener(type, handler._proxy);
	});
};
